// ── Defaults ───────────────────────────────────────────────────────────────
export const DEFAULT_ROE = {
    allowDestructive: false,
    rateLimitRps: 2,
};
//# sourceMappingURL=project.js.map